/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithTile_item = {
    readonly categoryPath: string | null;
    readonly ecommerceTrackingParams: unknown | null;
    readonly firstPhotoWebPath: string | null;
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly " $fragmentRefs": FragmentRefs<"ItemTile_item">;
    readonly " $refType": "ShoppingWithTile_item";
};
export type ShoppingWithTile_item$data = ShoppingWithTile_item;
export type ShoppingWithTile_item$key = {
    readonly " $data"?: ShoppingWithTile_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithTile_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShoppingWithTile_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": null
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "categoryPath",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "ecommerceTrackingParams",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstPhotoWebPath",
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small"
        }
      ],
      "storageKey": "firstPhotoWebPath(size:\"small\")"
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ItemTile_item",
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        }
      ]
    }
  ]
};
(node as any).hash = '13a4445f9e8e0b8662febf38e9922bf7';
export default node;
